import React, { Component } from 'react'
import { localize, getLocale } from '../../util/Localizer'

import Dialog from '@material-ui/core/Dialog'
import DialogTitle from '@material-ui/core/DialogTitle'
import DialogContent from '@material-ui/core/DialogContent'
import DialogActions from '@material-ui/core/DialogActions'

import RBButton from '../../controls/RBButton'

class Terms extends Component {
  constructor () {
    super()
    this.handleClose = this.handleClose.bind(this)
    this.handleOpen = this.handleOpen.bind(this)
    this.state = {
      open: false
    }
  }
  handleOpen (e) {
    e.preventDefault()
    this.setState({ open: true })
  }

  handleClose () {
    this.setState({ open: false })
  }
  render () {
    const actions = [
      <RBButton
        key='close'
        variant='outlined'
        label={localize('common.close')}
        onClick={this.handleClose}
      />
    ]
    const loc = getLocale()
    const { appContent = {} } = this.props
    const { contentItemText = {} } = appContent
    const { content = '' } = contentItemText[loc] || {}
    return (
      <div>
        <a onClick={this.handleOpen} id='terms'>{localize('common.terms.title')}</a>
        <Dialog
          open={this.state.open}
          onClose={this.handleClose}
        >
          <DialogTitle>{localize('common.terms.title')}</DialogTitle>
          <DialogContent>
            <div dangerouslySetInnerHTML={{ __html: content }}/>
            <DialogActions>{actions}</DialogActions>
          </DialogContent>
        </Dialog>
      </div>
    )
  }
}

export default Terms



// WEBPACK FOOTER //
// ./src/widgets/common/Terms.js